import { Box } from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../../constant";
import useDomainConfig from "../../../hook/useDomainConfig";

const PromoCardMobile = () => {
  const { animationLogoUrl } = useDomainConfig();

  return (
    <Box
      px="10px"
      // display={{
      //   base: "block",
      //   sm: "none",
      // }}
      mb="10px"
    >
      <Box
        h="120px"
        w="100%"
        borderRadius={`15px`}
        style={{
          backgroundImage: `url(${animationLogoUrl})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></Box>
    </Box>
  );
};

export default PromoCardMobile;
